import AuthPage from '../src/Pages/auth';
import Details from '../src/Pages/Details';
import FemaReportConsent from '../src/Pages/FemaReportConsent';
import { useLocation, Navigate } from 'react-router-dom';
import Home from '../src/Pages/Home';
import './App.css';
import Pending from './Pages/Pending';
import { AuthProvider } from './AuthContext';

function AppRoutes() {
  const location = useLocation();
  const hasToken = !!localStorage.getItem('access_token');

  // Auth page: always accessible
  if (location.pathname === '/auth') {
    return <AuthPage />;
  }

  // Protected utility routes: require a token
  if (location.pathname === '/user/user-details') {
    return hasToken ? <Details /> : <Navigate to="/auth" replace />;
  }

  if (location.pathname === '/pending-verification') {
    return hasToken ? <Pending /> : <Navigate to="/auth" replace />;
  }

  if (location.pathname === '/fema-report-consent') {
    return hasToken ? <FemaReportConsent /> : <Navigate to="/auth" replace />;
  }

  // Home: accessible to everyone (guests + authenticated)
  // AuthContext inside determines what features are available
  return <Home />;
}

function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}

export default App;